<template>
  <div>
    <el-image-viewer v-if="show" :on-close="closeViewer" :url-list="imgs" style="z-index:10000"></el-image-viewer>
  </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "ImagePreview",
  components:{
      ElImageViewer
  },
  props: {
    //通过调用组件传过来的值，可以直接用
    url: {//图片路径（多个用,隔开）
      type: String,
      default: '',
    }
  }, watch: {//监听 modal 值的变化,如果是显示的时候就重新获取表单信息
    show: {
      handler(IsShow) {
        if (IsShow) {
            let arr=this.url.split(',');
            this.imgs=arr;
        }
      },
      deep: true
    }
  },
  data() {
    return {
      show: false,
      imgs:[],
    };
  },
  methods: {
     closeViewer() {
      this.show = false;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ImagePreview.vue